/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ClinicLogo from '../../assets/SVG/img_logo_svg.svg';
import { useVerboseLog } from '../../utils/debug';
interface SemenAnalysisProps {
  data: any;
  iframeRef?: React.RefObject<HTMLIFrameElement>;
}

const SemenFreezingReport: React.FC<SemenAnalysisProps> = ({ data, iframeRef }) => {
  const verboseLog = useVerboseLog();
  verboseLog('data', data);

  const html = `<!DOCTYPE html>
    <html>
    <head>
    <meta charset="UTF-8">
    <style>
      body {
        font-family: Arial, sans-serif;
        padding: 40px;
        width: 794px;
        height: 1123px;
      }

      .header {
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #ccc;
        padding-bottom: 20px;
      }

      .info {
        background-color: #E1E1E1;
        padding: 16px;
        border-radius: 12px;
        max-width: 60%;
      }

      .info h1 {
        margin: 0;
        font-size: 28px;
      }

      .info p {
        margin: 4px 0;
        font-size: 14px;
      }

      .logo img {
        max-width: 196px;
      }

      h3 {
        margin-top: 30px;
        font-size: 20px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 4px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }

      th, td {
        border: 1px solid #000;
        padding: 6px;
        text-align: left;
      }

      th {
        background-color: #f0f0f0;
      }      
      .section-title {
        margin-top: 50px;
        font-size: 20px;
        padding-bottom: 5px;
      }
			.prefreezing-details p{
				margin: 8px 0px;
			}
			@media print {
				.page-break {
						break-before: page;
				}
			}
			.end_report {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
			}
		</style>
    </head>

    <body>
      <div class="header">
        <div class="info">
          <h1>PureCare Clinic</h1>
          <p>756 University Avenue, Lake Jeniferberg 35967</p>
          <p><strong>Email:</strong> ramon_morissette54@gmail.com</p>
          <p><strong>Mob:</strong> 578-778-3291 / 578-778-3291</p>
          <p><strong>Website:</strong> purecareclinic.com</p>
        </div>
        <div class="logo">
          <img src=${ClinicLogo} alt="Clinic Logo" />
        </div>
      </div>

      <h2>Semen Freezing Report</h2>
      
      <h3 class="section-title">1. Prefreezing Details</h3>
			<div class="prefreezing-details">
				<div  style="display: flex; justify-content: flex-start; align-items: center;">
					<p><strong>Cycle Number:</strong> ${data?.cycle_number ?? ''}</p>					
				</div>
				<div style="display: flex; justify-content: flex-start; align-items: center; pad">
					<p><strong>Sample Number:</strong> ${data?.sample_number ?? ''}</p>								
				</div>
				<div style="display: flex; justify-content: flex-start; align-items: center; pad">
					<p><strong>Date:</strong> ${data?.date ?? ''}</p>
				</div>
				<div style="display: flex; justify-content: flex-start; align-items: center; pad">
					<p><strong>Time:</strong> ${data?.time ?? ''}</p>
				</div>
				<div style="display: flex; justify-content: flex-start; align-items: center; pad">
					<p><strong>Status:</strong> ${data?.status ?? ''}</p>
				</div>
			</div>
			<table>
					<tbody>					
					<tr><th>Collection Method</th><td>${data.semen_collection_method}</td></tr>
					<tr><th>Extraction Type</th><td>${data.surgical_extraction_type}</td></tr>
					<tr><th>Collection Date</th><td>${data.collection_date}</td></tr>
					<tr><th>Collection Time</th><td>${data.collection_time}</td></tr>
					<tr><th>Receiving Date</th><td>${data.receiving_date}</td></tr>
					<tr><th>Receiving Time</th><td>${data.receiving_time}</td></tr>
					<tr><th>Abstinence Period</th><td>${data.abstinence_period} days</td></tr>
					<tr><th>Viscosity</th><td>${data.viscosity}</td></tr>
					<tr><th>Volume (ml)</th><td>${data.volume_ml}</td></tr>
					<tr><th>Sperm Concentration (million/ml)</th><td>${data.sperm_concentration_million_per_ml}</td></tr>
					</tbody>
			</table>

		<h3 class="page-break section-title">2. Cryo Preserved Detail</h3>
		
  ${data.cryo?.map((entry: any, index: number) => `
		${index === 0 ? 
    `<div class="prefreezing-details">
			<div  style="display: flex; justify-content: flex-start; align-items: center;">
				<p><strong>Patient Name & MRN:</strong> ${entry.patient_name ?? ''} ${entry.patient_last_name ?? ''} - ${entry.patient_mrn ?? ''}</p>					
			</div>
			<div style="display: flex; justify-content: flex-start; align-items: center; pad">
				<p><strong>Cycle Number:</strong> ${entry?.cycle_number ?? ''}</p>								
			</div>			
		</div>` : ''}
    <table>
      <thead>
        <tr>    
          <th>Cryo Date</th>
          <th>Volume (ml)</th>
          <th>Concentration</th>
          <th>Total Count</th>
          <th>Media Vol (µL)</th>
          <th>Semen Vol (µL)</th>
          <th>Preserved By</th>
          <th>Location</th>
          <th>Expiry Date</th>          
        </tr>
      </thead>
      <tbody>
        <tr>    
          <td>${entry.cryo_date?.split('T')[0] ?? '-'}</td>
          <td>${entry.volume ?? '-'}</td>
          <td>${entry.sperm_concentration_million_per_ml ?? '-'}</td>
          <td>${entry.total_sperm_count ?? '-'}</td>
          <td>${entry.media_volume ?? '-'}</td>
          <td>${entry.semen_volume ?? '-'}</td>
          <td>${entry.cryo_preserved_by_name ?? '-'}</td>
          <td>${entry.location_details?.hierarchy ?? '-'}</td>
          <td>${entry.expiry_date ?? '-'}</td>          
        </tr>
      </tbody>
    </table>
		
		<div class="prefreezing-details">
			<div style="display: flex; justify-content: flex-start; align-items: center; margin-top: 16px">
				<p><strong>Remark:</strong>${data.remark ?? ' -'}</p>					
			</div>			
		</div>
  `).join('')}

      <footer>
            <div class="end_report">
              <strong>End of Report</strong>
              <p>Note: This report is generated for informational purposes only and should not be considered as a medical advice.</p>            
            </div>        
        </footer>
    </body>
    </html>`;

  return (
    data && (
      <iframe
        title="SemenAnalysisReport"
        width="100%"
        height="100%"
        style={{ border: 'none', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}
        srcDoc={html}
        ref={iframeRef}
      />
    )
  );
};

export default SemenFreezingReport;
